import { Auth0ContextInterface, useAuth0 } from '@auth0/auth0-react'

/** @deprecated use Auth0ContextInterface */
export type UseAuth = Auth0ContextInterface

/** @deprecated use useAuth0 */
export const useAuth = useAuth0
